import { AfterContentInit, ChangeDetectorRef, Directive, ElementRef, Input, inject } from '@angular/core';
import { IonSelect } from '@ionic/angular';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'ion-select',
    standalone: false
})
export class IonicSelectDirective implements AfterContentInit {
  private readonly select = inject(IonSelect);
  private readonly element = inject(ElementRef);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() customShadowRootStyles?: string;

  constructor() {
    this.select.labelPlacement = 'floating';
    this.select.fill = 'outline';
    this.select.mode = 'md';
  }

  ngAfterContentInit(): void {
    if (this.customShadowRootStyles) this.applyCustomShadowRootStyles();
  }

  private applyCustomShadowRootStyles(): void {
    const root = this.element.nativeElement.shadowRoot;
    if (root !== null) {
      const styleElements = root.querySelectorAll('style');
      const alreadyHasStyles = Array.from(styleElements).some(
        (el: any) => el.innerHTML === styles,
      );
      const styles = this.customShadowRootStyles;
      if (styles && !alreadyHasStyles) {
        const newStyleTag = document.createElement('style');
        newStyleTag.innerHTML = styles;
        root.insertBefore(newStyleTag, root.querySelector('.select-wrapper'));
      }
    }
  }
}
